import { getApprovalMargins, postApprovalMargin, putApprovalMargin } from '../../../Api/services/backoffice';

export const key = 'approvalMargin';

const entityName = {
  singular: 'Margem de Aprovação',
  plural: 'Margens de Aprovação',
};

const queries = {
  list: { key, fn: getApprovalMargins },
  detail: { key },
};

const mutations = {
  create: postApprovalMargin,
  update: putApprovalMargin,
};

const fields = {
  table: [
    { key: 'margin', label: 'Margem Até' },
    { key: 'p.approver', label: 'P' },
    { key: 'm.approver', label: 'M' },
    { key: 'v.approver', label: 'V' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
